<script setup>
import { onMounted, useTemplateRef, ref, computed, useAttrs, nextTick, watch } from "vue";
import { useScrollStore } from "@/stores/storeScroll";
import { useSettingsStore } from "@/stores/storeSettings";
import { useFieldsStore } from "@/stores/storeFieldData";
import { useRequestsStore } from "@/stores/storeRequests";
import { useModals } from "@/utils/useModals";
import { RouterLink, useRoute, useRouter } from "vue-router";
import { sendMetrik } from "@/utils/metrika";
import BaseButtonUploadReceipt from "@/components/ui/BaseButtonUploadReceipt.vue";


const router = useRouter()

const { openModal } = useModals();
const storeScroll = useScrollStore();
const storeRequests = useRequestsStore();
const storeSettings = useSettingsStore();
const storeField = useFieldsStore();
const route = useRoute();

const header = useTemplateRef("header");
const userName = computed(() => {
	if (storeRequests.userData.first_name === undefined) {
		return "Профиль";
	} else {
		return `${storeRequests.userData?.first_name} ${storeRequests.userData.last_name?.slice(0, 1)}.`;
	}
});

const isProfilePage = computed(() => route.name === "profile" ? '--profile-page' : '' );

const isMobile = computed(() => storeSettings.widthWindow <= 1200);

const links = [
	{
		href: "header",
		label: "Главная",
	},
	{
		href: "collaboration",
		label: "Коллаборация",
	},
	{
		href: "restaurant",
		label: "Ресторан Поле",
	},
	{
		href: "collections",
		label: "Коллекция",
	},
	{
		href: "partners",
		label: "Где купить",
	},
	{
		href: "prizes",
		label: "Призы",
	},
	{
		href: "games",
		label: "Игры",
	},
	{
		href: "faq",
		label: "FAQ",
	},
];

const onMetrica = (key) => {
	// switch (key) {
	// 	case "participation":
	// 		sendMetrik("reachGoal", "klik_header_participate");
	// 		break;
	// 	case "prizes":
	// 		sendMetrik("reachGoal", "klik_header_prizes");
	// 		break;
	// 	case "winners":
	// 		sendMetrik("reachGoal", "klik_header_winners");
	// 		break;
	// 	case "products":
	// 		sendMetrik("reachGoal", "klik_header_products");
	// 		break;
	// 	case "footer":
	// 		sendMetrik("reachGoal", "klik_header_rules");
	// 		break;
	// 	case "faq":
	// 		sendMetrik("reachGoal", "klik_header_faq");
	// 		break;
	// }
};

const mobileMenuActive = ref(false);

defineProps({
	pageLoaded: {
		type: Boolean,
	},
});
const emit = defineEmits(["mobileMenuShow"]);
defineOptions({ inheritAttrs: false });
const attrs = useAttrs();

const mobileMenu = () => {
	if (storeSettings.widthWindow > 1200) return;

	mobileMenuActive.value = !mobileMenuActive.value;
	emit('mobileMenuShow')
	if (mobileMenuActive.value) {
		document.body.classList.add("noscroll");		
	} else {
		document.body.classList.remove("noscroll");		
	}
};

const clickBtnPfofile = () => {
	if (storeSettings.statusStockFuture) {
		openModal("promoNotStart");
	}

	if (storeSettings.statusStockPast || storeSettings.statusStockActive) {
		openModal("authorizationRequired");
	}
	// sendMetrik("reachGoal", "klik_button_profile");
};




onMounted( async() => {
	
	storeScroll.header = header.value;
	
});
</script>
<template>
	<div id="overlay" @click="mobileMenu" :class="{ active: mobileMenuActive }"></div>
	<header v-bind="attrs" :class="['header', isProfilePage, { '--fixed': storeScroll.headerFixed }, { active: mobileMenuActive }]" ref="header" >
		<div class="container --header">
			
			<div class="header__container">
				<div class="logos">
					<a href="https://www.tretyakovgallery.ru/" target="_blank" rel="noopener noreferrer" class="logo --gallery"><svg width="148" height="34"><use href="#logo_gallery"></use></svg></a>		
					<a href="https://tkmistral.ru/brands/mistral/" target="_blank" rel="noopener noreferrer" class="logo --mistral"><svg width="147" height="40"><use href="#logo_mistral"></use></svg></a>		
					<a href="https://pole.restaurant/" target="_blank" rel="noopener noreferrer" class="logo --place">
						<img class='logo-white' width="174" height="40" src='@/assets/img/logo_place.webp' alt='изображение'>
						<img class='logo-dark' width="174" height="40" src='@/assets/img/logo_place_dark.webp' alt='изображение'>
					</a>		
				</div>
				<nav class="nav">					
					<RouterLink 
						:to="`/#${link.href}`" 
						:class="['nav__link']" 
						@click="onMetrica(link.href), mobileMenu()"
						v-for="link in links" 
						:key="link.href"
					>
						{{ link.label }}
					</RouterLink>
					<div class="header__profile-btns --mobile">
						<button class="header-btn" v-if="!storeRequests.isAuthenticated" @click="clickBtnPfofile(), mobileMenu()">
							<svg width='32' height='32'><use href='#user'></use></svg>
							<span>Профиль</span>
						</button>
						<RouterLink @click="mobileMenu" class="header-btn" to="/profile" v-else>
							<svg width='32' height='32'><use href='#user'></use></svg>
							<span>{{ userName }}</span>
						</RouterLink>
						<button v-if="storeRequests.isAuthenticated" @click="storeRequests.logout(), mobileMenu()" class="btn-logout">
							<svg width="24" height="24"><use href="#logout"></use></svg>
						</button>
					</div>
				</nav>
				
				<div class="header__profile-btns --desktop">					
					<button class="header-btn" v-if="!storeRequests.isAuthenticated" @click="clickBtnPfofile(), mobileMenu()">
						<svg width='32' height='32'><use href='#user'></use></svg>
						<span>Профиль</span>
					</button>
					<RouterLink @click="mobileMenu" class="header-btn" to="/profile" v-else>
						<svg width='32' height='32'><use href='#user'></use></svg>
						<span>{{ userName }}</span>
					</RouterLink>
					<button v-if="storeRequests.isAuthenticated" @click="storeRequests.logout(), mobileMenu()" class="btn-logout">
						<svg width="24" height="24"><use href="#logout"></use></svg>
					</button>
				</div>

				<div @click="mobileMenu" :class="['nav-icon', { active: mobileMenuActive }]"><span></span></div>
			</div>
		</div>
	</header>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
@use "@/assets/scss/blocks/nav-icon";
.header {
	position: fixed;
	width: 100%;
	top: 0px;
	left: 0px;
	background-color: transparent;
	z-index: 4;
	padding: 3.8rem 0;
	transition:  0.2s ease-in;
	@media (max-width: vars.$x480) {
		padding: 1rem 0;
	}
	&.--fixed {
		background: var(--system-fill-light);
		padding: 1.6rem 0;
		border-bottom: 1px solid rgba(14, 14, 14, 0.16);
		@media (max-width: vars.$x480) {
			padding: .6rem 0;
		}
		&.active {
			.logo {
				--fill: #fff;
				&.--place {
					.logo-white {
						display: block;
					}
					.logo-dark {
						display: none;
					}
				}
			}
			.nav-icon span {
			&::before,
			&::after {
				content: "";
				background: #fff;
			}
		}
		.header-btn {
			font-size: 2rem;
			color: #fff;
			border-color: #fff;
		}
		.btn-logout {
			color: #fff;
			border-color: #fff;
			svg {
				width: 2.4rem;
				height: 2.4rem;
			}
		}
		}
		.logo {
			--fill: var(--text-accent-1-100);
			&.--place {
				.logo-white {
					display: none;
				}
				.logo-dark {
					display: block;
				}
			}
		}
		.header__profile-btns {
			height: 48px;
		}
		.header-btn {
			font-size: 2rem;
			color: var(--text-accent-1-100);
			border-color: rgba(14, 14, 14, 0.16);
			svg {
				width: 2.4rem;
				height: 2.4rem;
			}
			@media (hover: hover){
				&:hover {
					background: var(--fill-accent-1-1);
					color: var(--text-inverse-100);
					border-color: currentColor;
				}
			}
		}
		.btn-logout {
			color: var(--text-accent-1-100);
			border-color: rgba(14, 14, 14, 0.16);
			svg {
				width: 2.4rem;
				height: 2.4rem;
			}
			@media (hover: hover){
				&:hover {
					background: var(--fill-accent-1-1);
					color: var(--text-inverse-100);
					border-color: currentColor;
				}
			}
		}
		.nav__link {
			color: var(--text-accent-1-100);
			@media (max-width: vars.$l) {
				color: #fff;
			}
		}
		.nav-icon span {
			&::before,
			&::after {
				content: "";
				background: var(--text-accent-1-100);
			}
		}
	}
	&.active {
		.nav {
			left: 0;
			opacity: 1;
		}
	}
	&.--profile-page {
		
	}
}
.header__container {
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	@media (max-width: vars.$t) {
	}
}
.logos {
	display: flex;
	align-items: center;
	gap: 3rem;
	@media (max-width: vars.$x480) {
		gap: 1rem;
	}
}
.logo {
	position: relative;
    z-index: 3;
	--fill: #fff;
	svg {
		fill: var(--fill);
		stroke: transparent;
	}
	&.--gallery {
		svg {
			width: 14.8rem;	
			@media (max-width: vars.$xx) {
				width: 9rem;
			}		
		}
	}
	&.--mistral {
		display: flex;
    	align-items: center;
		border-right: 2px solid var(--fill);
		border-left: 2px solid var(--fill);
		padding: 0 2.8rem;
		height: 4rem;
		@media (max-width: vars.$lg) {
			padding: 0 2rem;
		}
		@media (max-width: vars.$x480) {
			padding: 0 1.4rem;
			height: 2.1rem;
		}
		svg {
			width: 9.1rem;
			@media (max-width: vars.$xx) {
				width: 5.5rem;
				border-width: 1px;
			}
		}
	}
	&.--place {
		img {
			width: 17.4rem;
			@media (max-width: vars.$xx) {
				width: 8rem;
			}
		}
		.logo-white {
			display: block;
		}
		.logo-dark {
			display: none;
		}
	}
}


.nav {
	display: flex;
	align-items: center;
	gap: .3rem;
	@media (max-width: vars.$l) {
		position: fixed;
		flex-direction: column;
		align-items: start;
		justify-content: space-between;
		z-index: 2;
		top: 0%;
		left: -100%;
		opacity: 0;
		padding: 100px var(--padding-container) 20px;
		
		background-image: url('@/assets/img/main/main_bg.webp');
		background-repeat: no-repeat;
		background-position: center; /* x y*/
		background-size: cover; /* w h*/
		width: 100%;
		max-width: 100%;
		gap: 8px;
		transition: all 0.5s ease-in;
		overflow-y: auto;
		height: 100dvh;
		
	}
	@media (max-width: vars.$xx) {
		padding: 90px var(--padding-container) 20px 25px;
		gap: 2px;
	}
}
.nav__link {
	font-family: var(--font-family);
	font-weight: 500;
	font-size: 1.6rem;
	line-height: 150%;
	color: #fff;
	border-radius: 10rem;
	padding: 0.6rem 1.8rem;
	border: 1px solid transparent;
	@media (hover: hover) {
		&:hover {
			border-color: currentColor;
		}
	}
	@media (max-width: vars.$lg) {
		padding: 0.6rem 1rem;
		font-size: 1.5rem;
	}
	@media (max-width: vars.$l) {
		font-size: 2rem;
	}
}

.header__profile-btns {
	display: flex;
	align-items: center;
	gap: 0.8rem;
	flex-shrink: 0;
	height: 6.4rem;
	@media (max-width: vars.$mn) {
		flex-wrap: wrap;
		width: 100%;
		
	}
	@media (max-width: vars.$x480) {
		gap: 0;
	}
	&.--desktop {
		@media (max-width: vars.$l) {
			display: none;
		}
	}
	&.--mobile {
		display: none;
		width: 100%;
		max-width: 37rem;
		gap: 0.8rem;
		@media (max-width: vars.$l) {
			display: flex;
			margin-top: auto;	
			justify-content: center;	
		}
		.header-btn {
			width: 78%;
			@media (max-width: vars.$x360) {
				width: 75%;
			}
		}
	}
}

.header-btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	position: relative;
	font-weight: 500;
	font-size: 2.4rem;
	line-height: 100%;
	color: #fff;
	border: 1px solid currentColor;
	border-radius: 10rem;
	padding: 0px 2.4rem;
	height: 100%;
	flex-shrink: 0;
	@media (max-width: vars.$lg) {
		padding: 0px 2.2rem;
	}
	@media (max-width: vars.$mn) {
		
	}
	@media (hover: hover) {
		&:hover {
			color: var(--text-accent-1-100);
			border-color: var(--fill-inverse-1);
			background: var(--fill-inverse-1);
		}
	}

	svg {
		width: 3.2rem;
		height: 3.2rem;
		fill: transparent;
		flex-shrink: 0;
	}
	span {
		max-width: 11rem;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		@media (max-width: vars.$l) {
			max-width: 18rem;
		}
	}

}

.btn-logout {
	display: flex;
	align-items: center;
	justify-content: center;
	border: 1px solid currentColor;
	border-radius: 50%;
	color: var(--fill-inverse-1);
	height: 100%;
	aspect-ratio: 1/1;
	svg {
		width: 2.4rem;
		height: 2.4rem;
		flex-shrink: 0;
		fill: transparent;
	}
	@media (hover: hover) {
		&:hover {
			color: var(--text-accent-1-100);
			border-color: var(--fill-inverse-1);
			background: var(--fill-inverse-1);
		}
	}
}

@keyframes animHeader {
	0% {
		transform: translateY(-100%);
		// opacity: 0;
	}
	100% {
		transform: translateY(0%);
		// opacity: 1;
	}
}
</style>
